// Navigation bar redirection and style starts
$(document).ready(function(){
	$('.custom_brand_nav').find("a").each(function() {
        var brand_link = $(this).attr('href');
        var site_url = $(location).attr('href');
        if(window.location.href.indexOf(brand_link) > -1){
        	$(this).addClass('active_nav_brand_logo');
        }
    });
});
// Navigation bar redirection and style ends
// -------------------------------------------------------------------------------------------------------------